import React from 'react';
import blackChevron from '../../../assets/shareReview/blackChevron.svg';
import { ColorPickerProps } from '../../type';

const ColorPicker: React.FC<ColorPickerProps> = ({ selectedColor, onColorChange }) => {
    return (
        <>
            <style>
                {`
                    #custom-color::-webkit-color-swatch-wrapper {
                        padding: 0;
                        border: none;
                    }
                    #custom-color::-webkit-color-swatch {
                        border: none;
                        border-radius: 9999px;
                    }
                `}
            </style>
            <label
                htmlFor="custom-color"
                className="w-11 h-6 pl-2 pr-0.5 py-0.5 bg-[#efefef] rounded-xl inline-flex justify-between items-center overflow-hidden cursor-pointer"
            >
                <div data-variant="Bottom" className="size-2 relative">
                    <img src={blackChevron} alt="blackChevron" className="w-[44px] h-auto" />
                </div>
                <div className="size-5 rounded-full" style={{ backgroundColor: selectedColor }} />
                <input
                    id="custom-color"
                    type="color"
                    value={selectedColor}
                    onChange={e => onColorChange(e.target.value)}
                    className="absolute opacity-0 w-0 h-0"
                />
            </label>
        </>
    );
};

export default ColorPicker;
